class TabbedCollection extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
      tab.addEventListener('keydown', this.onTabKeydown.bind(this));
    });

    requestAnimationFrame(() => {
      this.querySelectorAll('slider-component').forEach((slider) => this.patchSlider(slider));
    });
  }

  onTabClick(event) {
    event.preventDefault();
    this.activateTab(event.currentTarget);
  }

  onTabKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    if (currentIndex < 0) return;

    let nextIndex = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % this.tabs.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.tabs.length - 1;
    }

    if (nextIndex === null) return;

    event.preventDefault();
    this.tabs[nextIndex].focus();
    this.activateTab(this.tabs[nextIndex]);
  }

  activateTab(tab) {
    const panelId = tab.getAttribute('aria-controls');

    this.tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.setAttribute('tabindex', selected ? '0' : '-1');
      item.classList.toggle('tabbed-collection__tab--active', selected);
    });

    this.panels.forEach((panel) => {
      const active = panel.id === panelId;
      panel.hidden = !active;
      panel.classList.toggle('tabbed-collection__panel--active', active);

      if (active) {
        const slider = panel.querySelector('slider-component');
        if (slider) {
          const track = slider.querySelector('[id^="Slider-"]');
          if (track) track.scrollLeft = 0;
          if (typeof slider.resetPages === 'function') slider.resetPages();
          this.patchSlider(slider);
        }
      }
    });
  }

  /* Feature slide is wider than product slides; step by adjacent slide offset instead of fixed first-gap. */
  patchSlider(slider) {
    if (!slider || slider.dataset.tabbedPatched === 'true') return;
    if (typeof slider.onButtonClick !== 'function') return;

    slider.dataset.tabbedPatched = 'true';
    slider.onButtonClick = function onTabbedSliderButtonClick(event) {
      event.preventDefault();
      const items = Array.from(this.querySelectorAll('[id^="Slide-"]')).filter((element) => element.clientWidth > 0);
      if (!this.slider || items.length < 2) return;

      const origin = items[0].offsetLeft;
      let currentIndex = 0;
      items.forEach((item, index) => {
        if (item.offsetLeft - origin <= this.slider.scrollLeft + 1) currentIndex = index;
      });

      const targetIndex =
        event.currentTarget.name === 'next'
          ? Math.min(currentIndex + 1, items.length - 1)
          : Math.max(currentIndex - 1, 0);

      this.setSlidePosition(items[targetIndex].offsetLeft - origin);
    };
  }
}

customElements.define('tabbed-collection', TabbedCollection);
